import React from "react";
import { useEffect, useState } from "react";
import { fetchPriceFromSANA, getNewDesignRequest, getSteps, validateWizardSteps } from "./stores/wizard";
import QuickViewWizard from "./components/QuickView";
import Loading from "./components/commons/Loading";
import { FloatingAddToCartButton, OrderSummaryPanel } from "./components/QuickView/SideMenu";
import "./App.css";


function App() {
  const [loading, setLoading] = useState<boolean>(true);
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get("customerToken");
    const customerId = urlParams.get("customerId");

    if (authToken) {
      localStorage.setItem("customerToken", authToken);
    }

    if (customerId) {
      localStorage.setItem("customerId", customerId);
    }

    const fetchData = async () => {
      const storedToken = localStorage.getItem("customerToken");

      if (!storedToken) {
        throw new Error("No auth token found");
      }

      try {
        setLoading(true);
        await getNewDesignRequest();
        await getSteps({ updateSteps: true });
      } catch (error: any) {
        throw new Error(`Error fetching data: ${error?.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <Loading />;
  }

  const handleAddToCartClick = () => {
    const isValid = validateWizardSteps();

    if (isValid) {
      fetchPriceFromSANA();
      setIsPanelOpen(true);
    }
  }

  return (
    <React.Fragment>
      <div className="app-container w-full mb-8">
        <QuickViewWizard />
        <FloatingAddToCartButton
          onClick={handleAddToCartClick}
        />
        <OrderSummaryPanel
          isOpen={isPanelOpen}
          onClose={() => setIsPanelOpen(false)}
        />
      </div>
    </React.Fragment>
  );
}

export default App;